import { Navigation, Pagination } from 'swiper';

export const certificatesSetting = {
  modules: [Navigation, Pagination],
  slidesPerView: 2,
  spaceBetween: 30,
  loop: false,
  autoplay: true,
  speed: 800,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    320: {
      spaceBetween: 10,
      slidesPerView: 1,
    },
    768: {
      spaceBetween: 40,
    },
    1441: {
      spaceBetween: 30,
    },
  },
};
export const imageSliderSettings = {
  modules: [Pagination],
  slidesPerView: 1,
  loop: true,
  autoplay: true,
  speed: 800,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

export const eventsSliderSettings = {
  modules: [Navigation],
  slidesPerView: 1,
  loop: true,
  autoplay: true,
  speed: 800,
  navigation: {
    nextEl: '.swiper-new-events .swiper-button-next',
    prevEl: '.swiper-new-events .swiper-button-prev',
  },
};
export const eventsPastSliderSettings = {
  modules: [Navigation],
  slidesPerView: 1,
  loop: true,
  autoplay: true,
  speed: 800,
  navigation: {
    nextEl: '.swiper-past-events .swiper-button-next',
    prevEl: '.swiper-past-events .swiper-button-prev',
  },
};

export const PartnersSliderSettings = {
  modules: [Pagination],
  slidesPerView: 1,
  loop: false,
  autoplay: false,
  speed: 800,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

export const extraFeatSettings = {
  slidesPerView: 1,
  loop: false,
  autoplay: false,
  autoHeight: true,
  speed: 800,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

export const relatedGamesSettings = {
  slidesPerView: 2,
  loop: false,
  autoplay: false,
  speed: 800,
  spaceBetween: 30,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    320: {
      spaceBetween: 10,
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
  },
};

export const roadmapSliderSettings = {
  effect: 'coverflow',
  slidesPerView: 3,
  slideToClickedSlide: true,
  loop: true,
  centeredSlides: true,
  simulateTouch:true,
  allowTouchMove: false,
  speed: 400,
  coverflowEffect: {
    rotate: -12,
    stretch: 100,
    depth: 260,
    modifier: 1,
    slideShadows: false,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    init: function() {
      let id = $('.swiper-slide-active').attr('data-id');
      $('.data-listing .row').removeClass('current');
      $(`.data-listing .row[data-id=${id}]`).addClass('current');
    },
    slideChangeTransitionEnd: function() {
      let id = $('.swiper-slide-active').attr('data-id');
      $('.data-listing .row').removeClass('current');
      $(`.data-listing .row[data-id=${id}]`).addClass('current');
    },
  },
  breakpoints: {
    320: {
      slidesPerView: 1.2,
      effect: 'slide',
      allowTouchMove: true,
      spaceBetween: 10,
      updateOnWindowResize : true,
    },
    680: {
      slidesPerView: 2,
      updateOnWindowResize : true,
      coverflowEffect: {
        rotate: -16,
        stretch: 108,
        depth: 160,
        modifier: 1,
        slideShadows: false,
      },
    },
    769: {
      slidesPerView: 3,
    },
  },
};

export const gallerySliderSettings = {
  modules: [Navigation],
  slidesPerView: 3,
  spaceBetween: 30,
  loop: false,
  autoplay: true,
  speed: 800,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    320: {
      spaceBetween: 10,
      slidesPerView: 1,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
};

export const galleryPopSliderSettings = {
  modules: [Navigation, Pagination],
  spaceBetween: 10,
  loop: false,
  navigation: {
    nextEl: '.custom-pop .swiper-button-next',
    prevEl: '.custom-pop .swiper-button-prev',
  },
};

export const mobileGamesSliderSettings = {
  modules: [Navigation],
  spaceBetween: 10,
  slidesPerView: 1,
  loop: true,
  navigation: {
    nextEl: '.mobile-games-slider .swiper-button-next',
    prevEl: '.mobile-games-slider .swiper-button-prev',
  },
};



// WEBPACK FOOTER //
// ./scripts/exports/sliderSettings.js